import { Dialog } from "@mui/material";
import { useLocation, useNavigate } from "react-router";

import { NotifyEmails } from "./add/NotifyEmails";
import styles from "./ShareDialog.module.scss";

const ShareDialog = ({
  isShareModalOpenArg,
  setIsShareModalOpenArg,
  bulletinIDs,
}: {
  isShareModalOpenArg: boolean;
  setIsShareModalOpenArg: (arg: boolean) => void;
  bulletinIDs: number[];
}) => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const closeShareDialog = () => {
    setIsShareModalOpenArg(false);
    const newSearchParams = new URLSearchParams(search);
    newSearchParams.delete("share");
    navigate(`${pathname}?${newSearchParams.toString()}`);
  };

  return (
    <Dialog
      open={isShareModalOpenArg}
      onClose={closeShareDialog}
      className={styles.shareDialog}
    >
      <div style={{ minHeight: "40vh", minWidth: "600px" }}>
        <NotifyEmails
          bulletinIds={bulletinIDs}
          closeShareDialog={closeShareDialog}
        />
      </div>
    </Dialog>
  );
};

export default ShareDialog;
